import useBotControlStore from "../storeModules/useBotControlStore";
import LoadingDots from "../components/loadingDots";

const setLoadingMessage = () => {
  const messages = useBotControlStore.getState().messages;
  const loadingMessage = {
    id: "step-bot-loading",
    sender: "bot",
    text: "",
    loading: <LoadingDots size="small" color="primary" />,
  };

  useBotControlStore.setState({
    messages: [...messages, loadingMessage],
    isBotLoading: true,
  });
};

const setLoadingGifMessage = (gif) => {
  const messages = useBotControlStore.getState().messages;
  const loadingMessage = {
    id: "step-bot-loading",
    sender: "bot",
    text: "",
    loading: <img className="card-payment" src={gif} alt="Loading" />,
  };

  useBotControlStore.setState({
    messages: [...messages, loadingMessage],
    isBotLoading: true,
  });
};

const removeLoadingMessage = (timer = 0) => {
  const messages = useBotControlStore.getState().messages;

  const loadingIndex = messages.findIndex(
    (message) => message.id === "step-bot-loading"
  );

  if (loadingIndex !== -1) {
    const updatedMessages = [...messages];
    updatedMessages.splice(loadingIndex, 1);
    useBotControlStore.setState({
      messages: updatedMessages,
      isBotLoading: false,
    });
  }
};

export { setLoadingMessage, removeLoadingMessage, setLoadingGifMessage };
